import {
    useMemo,
} from 'react'

import Card from 'app/shared-components/Card'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'
import useTableStyles from 'app/tss/table.styles'
import useCardForTableStyles from 'app/tss/cardForTable'
import useLabel from 'app/hooks/useLabel'
import dateToDateStr from 'app/utils/date/dateToDateStr'

import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import {
    ContainerStatusBreakdownType,
} from '../ScenarioEditor.types'
import getColumns from './containerStatusBreakdown.columns'

const ContainerStatusBreakdown = ({
    serviceCenterId,
}: Readonly<{ serviceCenterId: number }>) => {
    const {
        classes: tableClasses,
    } = useTableStyles()
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const l = useLabel()

    const urlConfig = useMemo(() => {
        const url = requestConfig.getContainerStatusBreakdown({
            serviceCenterId,
        })

        return {
            customUrl: url.url,
            method: url.method,
            name: 'ContainerStatusBreakdown',
        }
    }, [serviceCenterId])

    const load: (params: any) => Promise<{
        items: ContainerStatusBreakdownType,
        matches: number
    }> = useLoadDtoForSkyNetTable(
        urlConfig,
    )

    const columns = useMemo(() => {
        return getColumns(l)
    }, [l])

    return (
        <Card
            className={cardClasses.root}
            title={`${l('CONTAINER_STATUS_BREAKDOWN_AS_OF')} ${dateToDateStr(Date.now())}`}
        >
            <RichTable
                configName="ContainerStatusBreakdownTable"
                name="ContainerStatusBreakdown"
                load={load}
                columns={columns}
                uniqField="id"
                className={tableClasses.tableContent}
                classNames={{
                    contentWrapper: tableClasses.tableContentWrapper,
                }}
            />
        </Card>
    )
}

export default ContainerStatusBreakdown
